// src/components/SessionInvitePanel.jsx
import React, { useState } from "react";

export default function SessionInvitePanel({
  friends,
  onInvite,
  busy = false,
}) {
  const [selectedIds, setSelectedIds] = useState(new Set());

  function toggle(id) {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }

  async function handleInviteClick() {
    if (!selectedIds.size || !onInvite || busy) return;
    const ids = Array.from(selectedIds);
    await onInvite(ids);
    // na succes selectie leegmaken
    setSelectedIds(new Set());
  }

  const hasFriends = friends && friends.length > 0;
  const hasSelection = selectedIds.size > 0;

  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        marginTop: 8,
        width: "100%",            // zelfde breedte als de knop-wrapper
        background: "#020617",
        borderRadius: 12,
        boxShadow: "0 18px 40px rgba(15,23,42,0.85)",
        border: "1px solid rgba(148,163,184,0.35)",
        overflow: "hidden",
        zIndex: 30,
      }}
    >
      {/* Scrollbare lijst */}
      <div
        style={{
          maxHeight: 220,         // ongeveer 5–6 cm
          overflowY: "auto",
          padding: "8px 0 4px 0",
        }}
      >
        {hasFriends ? (
          friends.map((f) => (
            <button
              key={f.id}
              type="button"
              onClick={() => toggle(String(f.id))}
              style={{
                width: "100%",
                padding: "8px 10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: selectedIds.has(String(f.id))
                  ? "rgba(79,70,229,0.14)"
                  : "transparent",
                border: "none",
                color: "#e5e7eb",
                cursor: "pointer",
                fontSize: 13,
              }}
            >
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  textAlign: "left",
                }}
              >
                {f.name || f.email || `User ${f.id}`}
              </span>
              <span
                style={{
                  width: 18,
                  height: 18,
                  borderRadius: 999,
                  border: selectedIds.has(String(f.id))
                    ? "0"
                    : "1px solid rgba(148,163,184,0.6)",
                  background: selectedIds.has(String(f.id))
                    ? "linear-gradient(135deg,#4f46e5,#ec4899)"
                    : "transparent",
                  display: "grid",
                  placeItems: "center",
                  fontSize: 11,
                }}
              >
                {selectedIds.has(String(f.id)) ? "✓" : ""}
              </span>
            </button>
          ))
        ) : (
          <div
            style={{
              padding: "10px 12px 12px 12px",
              fontSize: 12,
              color: "#9ca3af",
            }}
          >
            Je hebt nog geen Bond-vrienden om uit te nodigen.
          </div>
        )}
      </div>

      {/* Sticky Invite button */}
      <div
        style={{
          padding: "8px 10px 10px 10px",
          borderTop: "1px solid rgba(31,41,55,0.9)",
          background:
            "radial-gradient(circle at top, rgba(79,70,229,0.18), transparent 55%)",
        }}
      >
        <button
          type="button"
          disabled={!hasSelection || busy}
          onClick={handleInviteClick}
          style={{
            width: "100%",
            padding: "8px 14px",
            borderRadius: 999,
            border: "none",
            fontSize: 13,
            fontWeight: 500,
            cursor: !hasSelection || busy ? "default" : "pointer",
            opacity: !hasSelection || busy ? 0.6 : 1,
            background:
              "linear-gradient(135deg, #4f46e5 0%, #6366f1 40%, #ec4899 100%)",
            color: "#fff",
            boxShadow: "0 10px 30px rgba(15,23,42,0.9)",
          }}
        >
          {busy ? "Bezig..." : "Invite sturen"}
        </button>
      </div>
    </div>
  );
}
